"use client";
import { useSearch } from "@/context/SearchContext";
import { useService } from "@/hooks/serviceHook";
import { Col, Row, Select } from "antd";
import { Header } from "antd/es/layout/layout";
import get from "lodash/get";
import { useParams, usePathname } from "next/navigation";
import { useState } from "react";
import HeaderContent from "./HeaderContent";
import style from "./style.module.scss";
import AlgorithmModel from "./AlgorithmModel";
import CapabilityModel from "./CapabilityModel";
import FleetModel from "./FleetModel";
import { useRetrieveTitle } from "@/Utils/helpers";

const HeadNav = () => {
  const { handleLanguageChange, langOption, direction, defaultLanguage } = useRetrieveTitle();
  const { updateSearchQuery } = useSearch();
  const isActivePath: any = usePathname();
  const { id }: any = useParams();
  const serviceId: any = useParams();
  const dispatchId: any = useParams();
  const { data: serviceRes } = useService();
  const serviceList = get(serviceRes, "data", []);
  const serviceOptions = serviceList.map(({ service_id, name }) => ({
    label: name,
    value: service_id,
  }));

  const isNestedFleetsPage = [
    `/fleets/${id}`,
    `/fleets/${id}/vehicle-details`,
    `/fleets/${id}/driver-details`,
    "/dispatch/detail",
  ].includes(isActivePath);
  const isNestedHistoryPage = [`/history/${dispatchId}`].includes(isActivePath);
  const isNestedServicePage = [`/services/${serviceId}`].includes(isActivePath);

  const [fleetModelOpen, setFleetModelOpen] = useState(false);
  const [capabilityModelOpen, setCapabilityModelOpen] = useState<boolean>(false);
  const [serviceModalOpen, setServiceModalOpen] = useState<boolean>(false);

  const HeaderProps = {
    isActivePath,
    setFleetModelOpen,
    updateSearchQuery,
    isNestedHistoryPage,
    isNestedServicePage,
    isNestedFleetsPage,
    direction,
    setCapabilityModelOpen,
    serviceOptions,
    setServiceModalOpen,
  };
  return (
    <>
      <Header className={style.header}>
        {/* <Row className={style.header_wrapper}>
          <Col span={22} className={style.headerTitle}>
            <HeaderContent {...HeaderProps} />
          </Col>
          <Col span={2}>
            <Select
              key={defaultLanguage}
              size="middle"
              defaultValue={defaultLanguage}
              onChange={(val) => handleLanguageChange(val)}
              style={{ width: 100 }}
              options={langOption}
            />
          </Col>
        </Row> */}
        <Row className={style.header_wrapper}>
          <div className={style.headerLeft}>
            <HeaderContent {...HeaderProps} />
          </div>

          <div className={style.headerRight}>
            <Select
              key={defaultLanguage}
              size="middle"
              value={defaultLanguage}
              onChange={(val) => handleLanguageChange(val)}
              options={langOption}
              className={style.langSelect}
            />
          </div>
        </Row>
        <FleetModel
          open={fleetModelOpen}
          setOpen={setFleetModelOpen}
          services={serviceOptions}
        />
        <CapabilityModel
          open={capabilityModelOpen}
          setOpen={setCapabilityModelOpen}
        />
        <AlgorithmModel
          serviceId={serviceId?.serviceid}
          open={serviceModalOpen}
          setOpen={setServiceModalOpen}
        />
      </Header>
    </>
  );
};

export default HeadNav;
